import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './Welcome.css';
import config from "../../config";
import { getProjectCategory, getProjectApi, getItemListSize, putProjectViewCount } from "../../api";
const Welcome = () => {



  return (
    <section className="welcome-section py-4">
      <Container>
        <Row className="align-items-start ">
          <Col md={4}>
            <div className="welcome-image-container mt-2">
              <img
                src="images/tugikip/tugikipAnasayfa.png"
                alt="Türkiye Giyinme Kimliği Platformu Binası"
                className="welcome-image"
              />
            </div>
          </Col>
          <Col md={8}>
            <h2 className="welcome-title">Türkiye Giyinme Kimliği Platformu'na Hoş Geldiniz</h2>
            <div className="welcome-text">
              <p>
                Atatürk Kültür Merkezi Başkanlığı bir bilim ve kültür akademisi niteliğinde olup Türk kültürü üzerinde, araştırma,
                yayın, tanıtım, teşvik ve ödüllendirme faaliyetlerini sürdürmekte, devletin ve toplumun öncelikleriyle yakından
                ilgilenmektedir
              </p>
              <p>
              Atatürk Kültür Merkezi, kuruluşundan bu yana yüzlerce yayın yapmış, yurt içi ve yurt dışında çok sayıda
konferans ve bilimsel toplantı düzenlemiş, çeşitli konularda belgeseller hazırlamıştır. Ayrıca, bugüne kadar
edebiyat, sanat tarihi, tiyatro, resim, Türk müziği ve iletişim dallarında ödüllü yarışmalar açarak Türk kültürü
üzerinde araştırma yapanlara teşvik mahiyetinde ödüller vermiştir. Atatürk Kültür Merkezi Başkanlığı,
desteklediği küçük projelerin yanında, Kurum içi uluslararası nitelikte, kapsamlı projeler de yürütmüştür /
yürütmektedir.
              </p>
              <p>Ülkemizin kültürel ve doğal mirasının korunması, değerlendirilmesi, tanıtılması ve gelecek kuşaklara aktarılması konusunda, bilim ve kültür kurumlarına büyük sorumluluklar
              düşmektedir. Atatürk Kültür Merkezi Başkanlığı bu sorumluluğun bilinciyle diğer kurumlarla iş birliği içinde faaliyetlerini sürdürmektedir.</p>
            </div>
            {/* <a href="#details" className="read-more">devamını oku...</a> */}
          </Col>
        </Row>



      </Container>
    </section>
  );
};

export default Welcome; 